import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/brand.jpg");
